import app from 'firebase/app';
import 'firebase/auth';
const config = {

    apiKey: "AIzaSyADeARnJ6L378COd-Q-fmkQ0Bvn_XpWQIw",
    authDomain: "mil-guantes-ac620.firebaseapp.com",
    databaseURL: "https://mil-guantes-ac620.firebaseio.com",
    projectId: "mil-guantes-ac620",
    storageBucket: "mil-guantes-ac620.appspot.com",
    messagingSenderId: "344508617791",
    appId: "1:344508617791:web:67b6e3b44d7a9579b5548a",
    measurementId: "G-JYXKK5N2N3"
};

export default class Firebase {
    constructor() {
        app.initializeApp(config);
        this.auth = app.auth();
    }

    doSignInWithEmailAndPassword = (email, password) => {
        this.auth.signInWithEmailAndPassword(email, password)
    };

    doSignOut = () => this.auth.signOut();


}